module.exports = __webpack_public_path__ + "img/plus.1c33d93c.svg";